var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-save-profile-button-wrap",class:{ 'with-completion-banner': !_vm.hideCompletionBanner }},[_c('v-btn',{attrs:{"disabled":_vm.disabled,"depressed":"","color":"button"},on:{"click":function($event){return _vm.$emit('onButtonClick')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }